import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchChannelData from '../Services/fetchChannelData';

export default function useChannelsProductMasterData() {
	const { accessToken } = useAuth();

	const brandsQuery = useQuery({
		queryKey: ['channel'],
		queryFn: () => fetchChannelData({ accessToken }),
		staleTime: Infinity,
		retry: false,
	});

	return brandsQuery;
}
